import { useParams } from 'react-router-dom';
import { useState } from 'react';
import done from '../assets/done.svg';
import ReviewStack from '../components/ReviewStack';
import './Review.css'

import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://hsqjrdifsnxrkwyehhey.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhzcWpyZGlmc254cmt3eWVoaGV5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjk2NDgxMTQsImV4cCI6MjA0NTIyNDExNH0.PACJoo6iCmukz6LXGtDCfKwv2dUfzv1rI3FWw1DD3P0'
const supabase = createClient(supabaseUrl, supabaseKey)

const Review = () => {
    let { design_id } = useParams();
    const [earned, setEarned] = useState(0);

    const navigate = useNavigate();

    const earned5 = () => {
        setEarned(earned + 5);
    }

    const claimVC = async () => {
        const { data, error } = await supabase
            .from('designs') // Replace with your table name
            .select('*') // Select all columns (or specify specific ones)
            .eq('id', design_id) // Filter by the ID
            .single();
        await supabase
            .from('designs')
            .update({
                credits: data.credits + earned,
                last_claimed: new Date()
            })
            .match({ id: design_id }); // Use match to specify which row to update
        navigate(`/design/${design_id}`);
    };
    return (
        <div className="Review">
            <header className="Review-header">
                <div className="top">
                    <div className='success'>
                        <p>
                            Your design is uploaded
                        </p>
                        <img src={done} className="done" />
                    </div>
                    {earned > 0 &&
                        <div className='btn' onClick={claimVC}>
                            Get {earned} VibeChecks
                        </div>
                    }
                </div>
                <div className='give'>
                    Give 6 feedbacks and get 5
                </div>
                <ReviewStack earned5={earned5} design={design_id} />
            </header>
        </div>
    )
}

export default Review;